import PublishButton from './PublishButton.container';

export default PublishButton;
